import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { type VariantProps, cva } from 'class-variance-authority'
import { cn } from 'utils/cn'

const ProgressBarVariants = cva('', {
  variants: {
    size: {
      '2xs': 'h-0.5',
      sm: 'h-1',
      md: 'h-2',
      lg: 'h-3',
      xl: 'h-4',
      '2xl': 'h-6',
    },
  },
})
interface ProgressBarProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>,
    VariantProps<typeof ProgressBarVariants> {
  size?: '2xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  value: number
}

const Progressbar = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressBarProps
>(({ className, value, size = 'sm', ...props }, ref) => (
  <ProgressPrimitive.Root
    className={cn(
      ProgressBarVariants({ size }),
      'bg-text-200 relative overflow-hidden rounded-[62.4375rem]',
      className,
    )}
    data-testid='progress_root'
    ref={ref}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className='h-full w-full flex-1 transition-all'
      data-testid='progress_indicator'
      style={{
        transform: `translateX(-${100 - (isNaN(value) ? 0 : value)}%)`,
        background: 'linear-gradient(90deg, #00D5E0 1.02%, #ABE532 123.78%)',
      }}
    />
  </ProgressPrimitive.Root>
))
Progressbar.displayName = ProgressPrimitive.Root.displayName

export { Progressbar }
